import React, { useEffect, useState } from "react";
import store from "../../redux/store";
import {
  Card,
  Flex,
  Heading,
  Input,
  InputGroup,
  InputRightElement,
  Select,
  SimpleGrid,
  Spacer,
  Text,
} from "@chakra-ui/react";
import { FiChevronLeft, FiChevronRight, FiSearch } from "react-icons/fi";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import DisplayData from "../../components/DisplayData";
import { get_godown_list } from "../../redux/godownSlice";

const GodownList = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState(5);
  const [page, setpage] = useState(1);
  const [initialValue, setInitialValue] = useState(1);
  const { godown_list, total_godown_count } = useSelector(
    (state) => state.godown
  );

  useEffect(() => {
    store.dispatch(get_godown_list({ page: page, rows: rows }));
  }, []);
  const onPrevious = () => {
    initialValue == 1 || setInitialValue(Number(initialValue) - Number(rows));
    page == 1 || setpage(page - 1);
    page === 1 ||
      store.dispatch(get_godown_list({ page: page - 1, rows: rows }));
  };

  const onNext = () => {
    rows * page >= total_godown_count ||
      setInitialValue(Number(initialValue) + Number(rows));
    rows * page >= total_godown_count || setpage(page + 1);
    rows * page >= total_godown_count ||
      store.dispatch(get_godown_list({ page: page + 1, rows: rows }));
  };
  return (
    <>
      <Card
        bg={"#fff"}
        paddingInline={5}
        paddingBlock={2}
        flexDirection={["column", "column", "row"]}
        align={["start", "start", "center"]}
      >
        <Heading fontSize={"xl"}>Godown List</Heading>
        <Spacer />
        <Flex alignItems={"center"} gap={2} mr={2}>
          {/* <Text>Item limit :</Text> */}
          <Select
            placeholder=""
            size={"md"}
            w={"15"}
            value={rows}
            onChange={(e) => {
              store.dispatch(
                get_godown_list({ page: page, rows: e.target.value })
              );
              setRows(e.target.value);
            }}
          >
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </Select>
        </Flex>
        <InputGroup bg={"#f4f5f7"} maxW={"sm"} borderRadius={5}>
          <Input placeholder="Search..." />
          <InputRightElement>
            <FiSearch />
          </InputRightElement>
        </InputGroup>
      </Card>
      <SimpleGrid minChildWidth="xs" spacing="10px">
        {godown_list.map((el, i) => (
          <Card
            paddingInline={5}
            paddingBlock={2}
            cursor={"pointer"}
            onClick={() =>
              navigate("/godown-list/godown-detail", { state: el.id })
            }
          >
            <DisplayData
              fs={"16px"}
              v_color={"#007bc9"}
              fw={"bold"}
              value={el.name}
            />
            <DisplayData title={"Address"} value={el.address} />
            <DisplayData title={"License No."} value={el.license_no} />
            <DisplayData
              title={"Storage Capacity"}
              value={el.storage_capacity}
            />
          </Card>
        ))}
      </SimpleGrid>
      <Card
        alignItems={"center"}
        alignSelf={"end"}
        gap={3}
        flexDirection={"row"}
      >
        <FiChevronLeft
          cursor={"pointer"}
          color={page == 1 ? "gray" : "#007bc9"}
          size={35}
          onClick={onPrevious}
        />
        <Flex gap={3}>
          <Text>{initialValue}</Text>-
          <Text>
            {rows * page >= total_godown_count
              ? total_godown_count
              : rows * page}
          </Text>
          <Text>of</Text>
          <Text>{total_godown_count}</Text>
        </Flex>
        <FiChevronRight
          cursor={"pointer"}
          color={rows * page >= total_godown_count ? "gray" : "#007bc9"}
          size={35}
          onClick={onNext}
        />
      </Card>
    </>
  );
};

export default GodownList;
